<template>
	<svg :width="width" :height="height" :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.0504 10.0021L12.61 11.7848L14.7071 13.1249L15.0728 10.0131L14.7071 6.97068L12.5698 8.14814L11.0504 10.0021Z" fill="#00832D"/>
		<path d="M2 12.8361V15.4872C2 16.0933 2.49092 16.5842 3.09702 16.5842H5.74814L6.29665 14.5803L5.74814 12.8361L3.92892 12.2876L2 12.8361Z" fill="#0066DA"/>
		<path d="M5.74814 3.42L2 7.16814L3.92892 7.71665L5.74814 7.16814L6.28751 5.44765L5.74814 3.42Z" fill="#E94235"/>
		<path d="M5.74814 7.16814H2V12.8361H5.74814V7.16814Z" fill="#2684FC"/>
		<path d="M17.1023 5.00702L14.7071 6.97068V13.1249L17.1132 15.0977C17.4734 15.3793 18 15.1224 18 14.6644V5.4312C18 4.96771 17.4615 4.71356 17.1023 5.00702ZM11.0504 10.0021V12.8361H5.74814V16.5842H13.6101C14.2162 16.5842 14.7071 16.0933 14.7071 15.4872V13.1249L11.0504 10.0021Z" fill="#00AC47"/>
		<path d="M13.6101 3.42H5.74814V7.16814H11.0504V10.0021L14.7071 6.97251V4.51702C14.7071 3.91091 14.2162 3.42 13.6101 3.42Z" fill="#FFBA00"/>
	</svg>
</template>

<script>

export default {
	name: "GoogleMeetIcon",
	props: {
		width: {
			type: Number,
			default: 20,
		},
		height: {
			type: Number,
			default: 20,
		},
	},
	computed: {
		viewBox() {
			const { width, height, } = this;
			return `0 0 ${ width } ${ height }`;
		},
	},
};
</script>

<style lang="scss" scoped></style>
